// @ts-nocheck
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { Component } from 'react';
import _ from 'lodash';
import { inject, observer } from "../../../../../stores/mobx-compat";

import Card from '../../../../ui/Card';
import Button from '../../../../ui/Button';
import IconButton from '../../../../ui/IconButton';
import Pill from '../../../../ui/Pill';
import Modal, { ModalActions } from '../../../../ui/Modal';
import Table, { Th, Td, Tr, TableToolbar } from '../../../../ui/Table';
import { EditIcon, PlusIcon, XIcon, TagIcon } from '../../../../ui/icons';

class DripCampaigns extends Component {
  state = {
    modalOpen: false,
    formDomainToBeUpdated: null,
    formPathToBeUpdated: null,
    newCampaignArray: [],
  }

  openModal = (formDomainToBeUpdated, formPathToBeUpdated) => {
    const list = this.props.store.integrations.OMI366
      .assignedDripCampaigns[formDomainToBeUpdated][formPathToBeUpdated].campaignIds;
    this.setState({
      formDomainToBeUpdated,
      formPathToBeUpdated,
      modalOpen: true,
      newCampaignArray: list,
    });
  }

  closeModal = () => this.setState({
    modalOpen: false,
    formDomainToBeUpdated: null,
    formPathToBeUpdated: null,
    newCampaignArray: [],
  });

  rows() {
    const out = [];
    const assigned = this.props.store.integrations.OMI366.assignedDripCampaigns;
    const available = this.props.store.integrations.OMI366.availableDripCampaigns;
    Object.keys(assigned).forEach((domain) => {
      Object.keys(assigned[domain]).forEach((path) => {
        out.push(
          <Tr key={`${domain}${path}`}>
            <Td mono>{domain}{path}</Td>
            <Td>
              <div className="flex flex-wrap gap-1.5">
                {assigned[domain][path].campaignIds.map((id) => {
                  const name = _.get(available, [id, 'CampaignName']);
                  if (!name) return null;
                  return <Pill key={id} tone="green">{name}</Pill>;
                })}
              </div>
            </Td>
            <Td align="right">
              <IconButton variant="ghost" icon={EditIcon} ariaLabel="Edit" onClick={() => this.openModal(domain, path)} />
            </Td>
          </Tr>,
        );
      });
    });
    return out;
  }

  render() {
    const omi = this.props.store.integrations.OMI366;
    const rows = this.rows();
    return (
      <>
        <Card padded={false}>
          <TableToolbar title="Drip campaigns" />
          <Table>
            <thead>
              <tr>
                <Th>Form URL</Th>
                <Th>Drip campaigns</Th>
                <Th align="right">Actions</Th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </Card>

        <Modal
          open={this.state.modalOpen}
          onClose={this.closeModal}
          size="md"
          title="Edit campaign assignments"
          icon={TagIcon}
          actions={(
            <ModalActions
              onCancel={this.closeModal}
              onConfirm={async () => {
                await omi.updateDripCampaigns(
                  this.state.formDomainToBeUpdated,
                  this.state.formPathToBeUpdated,
                  this.state.newCampaignArray,
                );
                this.closeModal();
              }}
              confirmLabel="Update"
              confirmLoading={omi.loading}
            />
          )}
        >
          <div className="mb-4">
            <div className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute mb-2">
              Available
            </div>
            <div className="flex flex-wrap gap-2">
              {Object.keys(omi.availableDripCampaigns)
                .filter((id) => !this.state.newCampaignArray.includes(id))
                .map((id) => (
                  <Button
                    key={id}
                    variant="default"
                    size="sm"
                    icon={PlusIcon}
                    onClick={() => this.setState({
                      newCampaignArray: [...this.state.newCampaignArray, id],
                    })}
                  >
                    {omi.availableDripCampaigns[id].CampaignName}
                  </Button>
                ))}
            </div>
          </div>
          <div>
            <div className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute mb-2">
              Assigned
            </div>
            <div className="flex flex-wrap gap-2">
              {this.state.newCampaignArray.map((id) => (
                <Button
                  key={id}
                  variant="accent-soft"
                  size="sm"
                  iconRight={XIcon}
                  onClick={() => this.setState({
                    newCampaignArray: this.state.newCampaignArray.filter((c) => c !== id),
                  })}
                >
                  {omi.availableDripCampaigns[id]?.CampaignName}
                </Button>
              ))}
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default inject('store')(observer(DripCampaigns));
